import React, { Component } from "react";

import Icon from "../../prefabs/icon/view";



class SummaryItem extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);

    this.cachedError = null;
  }



  // ===============================================================================================
  onClick(e) {
    e.preventDefault();
    // console.log(`SUMMARY:\n Clicked location: ${this.props.details.id} : ${this.props.details.name}`);
    if (!this.props.inactive) {
      this.props.handleClick(this.props.type);
    }
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Collect summary/error info
    let viewSummaryLabel    = null;
    let viewSummarySublabel = null;
    let viewSummaryError    = null;

    if (this.props.summary) {
      viewSummaryLabel    = (this.props.summary.label)    ? this.props.summary.label    : null;
      viewSummarySublabel = (this.props.summary.sublabel) ? this.props.summary.sublabel : null;
    }

    if (this.props.error) {
      viewSummaryError = (this.props.error.label) ? this.props.error.label : null;
    }



    // ---------------------------------------------------------------------------------------------
    // Get icon colour (different if visited)
    // let icon = (this.props.visited) ? `sec-${this.props.type}` : `sec-${this.props.type}-w`;



    // ---------------------------------------------------------------------------------------------
    // Check if an error exists
    let showError = (this.props.visited && viewSummaryError !== null) ? true : false;
    if (this.cachedError !== viewSummaryError && viewSummaryError !== null) {
      this.cachedError = viewSummaryError;
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className={"summary-item-container" +
        ((this.props.active === this.props.current) ? " summary-item--active" : "") +
        ((this.props.active !== this.props.current) ? " summary-item--inactive" : "")}>



        <button className="summary-item"
          tabIndex="-1"
          onClick={this.onClick}>

          <div className="summary-item__left">
            {this.props.current - 1}
            {/* <Icon type={icon} /> */}
          </div>

          <div className="summary-item__middle">

            <div className="summary-item__main">
              {viewSummaryLabel}
            </div>

            <div className={"summary-item__sub" +
              ((!viewSummarySublabel) ? "summary-item__sub--hidden" : "")}>
              {viewSummarySublabel}
            </div>

          </div>

          <div className="summary-item__right">
            <Icon type="pen" />
          </div>

        </button>



        <div className={"summary-error" +
          ((showError) ? " summary-error--shown" : "")}>

          <div className="summary-error__message">
            {this.cachedError}
          </div>

        </div>



      </div>
    );
  }

}



export default SummaryItem
